import React, { Component } from 'react'
import './navBar.css'
import FA from 'react-fontawesome'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { setLanguage } from '../../store/actions/language'
import { login } from '../../store/actions/auth'

class NavBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dillerOpen: false,
            adminOpen: false
        }
    }

    async setLanguageNav(lang) {
        await setLanguage(lang);
        window.location.reload(false)
    }

    render() {
        if (!this.props.token) {
            this.props.logout(this.props.token)
            return (
                <div></div>
            )
        } else {
            this.props.logout(this.props.token)
            return (
                <>
                    <div className="navbar-container">
                        <div className="navbar-shared navbar-left">
                            <Link className="main-a" to="/bitkiCesitleri">Panel</Link>
                            <ul className="ul-main">
                                <li><Link to="/bitkiCesitleri">Bitki Çeşitleri</Link></li>
                                <li><Link to="/bitkiSekilleri">Bitki Şekilleri</Link></li>
                                <li><Link to="/boyutlar">Boyutlar</Link></li>
                                <li><Link to="/renkler">Renkler</Link></li>
                                <li><Link to="/sonucCicek">Sonuç Çiçek</Link></li>
                                <li><Link to="/agacCali">Ağaç Çalı</Link></li>
                                <li><Link to="/yaprakTipi">Yaprak Tipi</Link></li>
                                <li><Link to="/yaprakSekli">Yaprak Şekli</Link></li>
                                <li><Link to="/sonucAgac">Sonuç Ağaç</Link></li>

                            </ul>
                        </div>
                        <div className="navbar-shared navbar-right">
                            <ul className="ul-right">
                                <li
                                    className={"navbar-option-list " + (this.state.adminOpen && "navbar-option-clicked-color")}
                                    onClick={() => this.setState({ adminOpen: !this.state.adminOpen, dillerOpen: false })}
                                >
                                    <Link>Admin <FA className="arrow-down" name="sort-down" /></Link>
                                    {this.state.adminOpen &&
                                        <div className="navbar-options-tab">
                                            <div className="navbar-option-item" onClick={async () => { await login(""); window.location.href = "/login" }}>Güvenli Çıkış</div>
                                        </div>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </>
            )
        }

    }
}

export default connect((store) => ({ language: store.language.language, token: store.auth.token, percentage: store.percentage.percentage }), { setLanguage })(NavBar)
